.peep-top-right-info {
    position: relative;
    padding: 16px 32px;
}

.peep-top-right-info button {
    text-decoration: underline !important;
}
